module.exports = __webpack_public_path__ + "assets/outside_of_service_area.8ce2d5a2.svg";